import { createContext, useContext, useState } from "react";

const CloseLeadContext = createContext();

export const CloseLeadContactProvider = ({ children }) => {
  const [closeLeadData, setCloseLeadData] = useState(null);
  const [closeLeadFormData, setCloseLeadFormData] = useState(null); // NEW: Store form data

  const saveCloseLeadData = (leadData) => {
    setCloseLeadData(leadData);
  };

  const clearCloseLeadData = () => {
    setCloseLeadData(null);
  };

  // NEW: Save close lead form data (for API call after business activity submission)
  const saveCloseLeadFormData = (formData) => {
    setCloseLeadFormData(formData);
  };

  // NEW: Clear close lead form data
  const clearCloseLeadFormData = () => {
    setCloseLeadFormData(null);
  };

  return (
    <CloseLeadContext.Provider
      value={{
        closeLeadData,
        saveCloseLeadData,
        clearCloseLeadData,
        closeLeadFormData, // NEW
        saveCloseLeadFormData, // NEW
        clearCloseLeadFormData, // NEW
      }}
    >
      {children}
    </CloseLeadContext.Provider>
  );
};

export const useCloseLeadContext = () => {
  const context = useContext(CloseLeadContext);
  if (!context) {
    throw new Error(
      "useCloseLeadContext must be used within CloseLeadContactProvider"
    );
  }
  return context;
};
